import type { Regimen } from "@/data/meal-plan";

export type DayOfWeek = "mon" | "tue" | "wed" | "thu" | "fri" | "sat" | "sun";

export const DAYS_OF_WEEK: { id: DayOfWeek; label: string }[] = [
  { id: "mon", label: "Lun" },
  { id: "tue", label: "Mar" },
  { id: "wed", label: "Mié" },
  { id: "thu", label: "Jue" },
  { id: "fri", label: "Vie" },
  { id: "sat", label: "Sáb" },
  { id: "sun", label: "Dom" },
];

/** A single pick within a ChoiceGroup — which option and how many times */
export interface Selection {
  optionId: string;
  count: number;
}

/**
 * Legacy selection format from before id-based migration.
 * Only exists in saved plans that haven't been migrated yet.
 */
export interface LegacySelection {
  optionIndex: number;
  count: number;
}

/** All selections for one ChoiceGroup */
export interface ChoiceGroupSelections {
  selections: Selection[];
  skipped: boolean;
  /** Per-slot eaten state (length matches expanded slot count) */
  eaten?: boolean[];
}

/** All choice-group selections for one meal */
export type MealSelections = ChoiceGroupSelections[];

/** A full day's plan */
export interface DayPlan {
  regimenId: Regimen["id"] | null;
  meals: MealSelections[] | null;
  /** Per-meal notes (keyed by meal index), e.g. "estofado", "lomo saltado" */
  mealNotes?: Record<number, string>;
  /** Chosen menu id per meal index, for meals that define `menus` */
  mealMenus?: Record<number, string>;
}

/** The entire week */
export type WeekPlan = Record<DayOfWeek, DayPlan>;

/** Default regimen assignment per day of week */
export type RegimenPresets = Record<DayOfWeek, Regimen["id"] | null>;

export const EMPTY_DAY: DayPlan = { regimenId: null, meals: null };

export function createEmptyWeek(): WeekPlan {
  return {
    mon: { ...EMPTY_DAY },
    tue: { ...EMPTY_DAY },
    wed: { ...EMPTY_DAY },
    thu: { ...EMPTY_DAY },
    fri: { ...EMPTY_DAY },
    sat: { ...EMPTY_DAY },
    sun: { ...EMPTY_DAY },
  };
}
